// @flow
import config from '../../config';
import { buildQueryParams } from './search-optimizations-request';
import { createApiCall } from './api-factory';

const BASE_URL = config.OPERATIONAL_OPTIMIZATION_ANALYTICS_URL;

const makeApiCall = createApiCall(BASE_URL, buildQueryParams);

const getGroundVsAir = (query) => makeApiCall('/ground_vs_air', query);

const getOptimizedGroundVsAir = (query) => makeApiCall('/optimized_ground_vs_air', query);

const getGroundVsAirDetails = (query) => makeApiCall('/ground_vs_air_details', query);

const getOptimizedGroundVsAirDetails = (query) =>
    makeApiCall('/optimized_ground_vs_air_details', query);

export {
    getGroundVsAir,
    getOptimizedGroundVsAir,
    getGroundVsAirDetails,
    getOptimizedGroundVsAirDetails
};
